import { createContext } from 'react';
var DataProviderContext = createContext(null);
DataProviderContext.displayName = 'DataProviderContext';
export default DataProviderContext;